// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Ethers$SensumPwa from "../../blockchain/eth/ethers/Ethers.bs.js";
import * as RescriptReactRouter from "@rescript/react/src/RescriptReactRouter.bs.js";
import * as Core_Ui_Navbar$SensumPwa from "../../core/ui/navbar/Core_Ui_Navbar.bs.js";

function Pages_Configuration$SubscribeButton(Props) {
  var match = React.useState(function () {
        return Notification.permission;
      });
  var setSubscribed = match[1];
  if (match[0] === "granted") {
    return React.createElement("button", {
                className: "bg-purple-900",
                disabled: true,
                type: "button"
              }, "Notifications Allowed");
  } else {
    return React.createElement("button", {
                className: "bg-purple-900",
                type: "button",
                onClick: (function (param) {
                    Notification.requestPermission().then(function (str) {
                          Curry._1(setSubscribed, (function (param) {
                                  return str;
                                }));
                          return Promise.resolve(str);
                        });
                  })
              }, "Allow Notifications");
  }
}

var SubscribeButton = {
  make: Pages_Configuration$SubscribeButton
};

function Pages_Configuration$NetworkForm(Props) {
  var config = Props.config;
  var saveConfig = Props.saveConfig;
  var match = React.useState(function () {
        return config.sensationsContractAddress;
      });
  var setSensationsContractAddressInput = match[1];
  var sensationsContractAddressInput = match[0];
  var match$1 = React.useState(function () {
        return config.networkUrl;
      });
  var setNetworkInput = match$1[1];
  var networkUrlInput = match$1[0];
  var onChangeSensationsContractAddressInput = function ($$event) {
    var updatedValue = $$event.target.value;
    Curry._1(setSensationsContractAddressInput, (function (param) {
            return updatedValue;
          }));
  };
  var onChangeNetworkUrlInput = function ($$event) {
    var updatedValue = $$event.target.value;
    Curry._1(setNetworkInput, (function (param) {
            return updatedValue;
          }));
  };
  var onSave = function (_event) {
    var result = Curry._2(saveConfig, networkUrlInput, sensationsContractAddressInput);
    if (result.TAG === /* Ok */0) {
      return RescriptReactRouter.push("/dsensum/#graveyard");
    }
    console.log("Error: ", result._0);
  };
  return React.createElement("div", {
              className: "my-10 grid grid-flow-row gap-3 place-content-center"
            }, React.createElement("label", {
                  className: "text-xl text-purple-50",
                  htmlFor: "networkInput"
                }, "Network (blockchain provider)"), React.createElement("input", {
                  className: "form-control px-2",
                  id: "networkInput",
                  placeholder: "http://127.0.0.1:8545",
                  value: networkUrlInput,
                  onChange: onChangeNetworkUrlInput
                }), React.createElement("label", {
                  className: "text-xl text-purple-50",
                  htmlFor: "sensationsContractAddress"
                }, "Channel (contract address)"), React.createElement("textarea", {
                  className: "form-control px-2 resize-none",
                  id: "sensationsContractAddress",
                  placeholder: "0x...",
                  value: sensationsContractAddressInput,
                  onChange: onChangeSensationsContractAddressInput
                }), React.createElement(Pages_Configuration$SubscribeButton, {}), React.createElement("label", {
                  className: "text-xs text-right text-zinc-400"
                }, "ethers v" + Ethers$SensumPwa.getLibraryVersion(undefined) + ""), React.createElement("button", {
                  className: "text-md px-2 text-purple-50 border-2 border-solid border-purple-50  disabled:opacity-50 hover:bg-purple-900",
                  disabled: networkUrlInput === "" || sensationsContractAddressInput === "",
                  onClick: onSave
                }, "SAVE"));
}

var NetworkForm = {
  make: Pages_Configuration$NetworkForm
};

function Pages_Configuration(Props) {
  var config = Props.config;
  var saveConfig = Props.saveConfig;
  return React.createElement("div", {
              className: "bg-black flex flex-col h-screen overflow-hidden"
            }, React.createElement(Core_Ui_Navbar$SensumPwa.make, {}), React.createElement("main", {
                  className: "overflow-y-scroll"
                }, React.createElement(Pages_Configuration$NetworkForm, {
                      config: config,
                      saveConfig: saveConfig
                    })));
}

var make = Pages_Configuration;

export {
  SubscribeButton ,
  NetworkForm ,
  make ,
}
/* react Not a pure module */
